//imgs
import Icon1 from "../../../assets/imgs/job-placement/icon1.png";
import Icon2 from "../../../assets/imgs/job-placement/icon2.png";

export const CAREER_OPTIONS_DATA = [
  {
    subHeading: "living",
    heading1: "Affordable",
    heading2: "Living",
    IconImg: Icon1,
    details: [
      { txt: "Work in hospitals" },
      { txt: "Clinic" },
      { txt: "Outpatient care centers" },
    ],
  },
  {
    subHeading: "English",
    heading1: "English-Taught",
    heading2: "Courses",
    IconImg: Icon2,
    details: [{ txt: "Serve in nursing homes or provide at-home care" }],
  },
  {
    subHeading: "top",
    heading1: "Top-Ranking",
    heading2: "Universities",
    IconImg: Icon1,
    details: [{ txt: "Specialize in caring for children and adolescents" }],
  },
  {
    subHeading: "job",
    heading1: "Huge Work",
    heading2: "Opportunities",
    IconImg: Icon2,
    details: [{ txt: "ICU, surgical, or emergency care." }],
  },
  {
    subHeading: "Course",
    heading1: "Countless Courses",
    heading2: "Offered",
    IconImg: Icon1,
    details: [{ txt: "Manage healthcare teams and facilities." }],
  },
  {
    subHeading: "visa",
    heading1: "Easier Visa",
    heading2: "PR Process",
    IconImg: Icon2,
    details: [{ txt: "Train the next generation of healthcare professionals" }],
  },
];
